module.exports = __webpack_public_path__ + "static/media/matic.b156ebec.png";